import ky from '../ky';

export const getTranslations = () => ky.get(`Translations`);
